import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MentorBookSessionDialogComponent } from '../mentor-book-session-dialog/mentor-book-session-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GetMentorList } from '@edtech-ui/core/models/mentors-sessions/get-all-mentors';
import { MentorService } from '@edtech-ui/core/services/mentor-management/mentor.service';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from 'environments/environment';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';

@Component({
	selector: 'app-all-mentors',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatTooltip, MatProgressSpinnerModule,
		HasPermissionDirective
	],
	templateUrl: './all-mentors.component.html',
	styleUrl: './all-mentors.component.scss'
})
export class AllMentorsComponent implements OnInit, OnDestroy {

	mentors: GetMentorList[] = [];
	mentorsCount: number = 0;
	subscription = new Subscription();
	isLoadingIndex: number | null = null;
	isMentor = false;
	page = 1;
	limit = 10;
	totalPages = 0;
	PermissionForStudents = PermissionForStudents;
	mentorEmail: string | null = null;

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private _mentorService: MentorService,
		private _toastr: ToastrService,
		private route: ActivatedRoute,

	) { }

	ngOnInit(): void {
		// this.route.queryParams.subscribe(params => {
		// 	const code = params['code'];
		// 	if (code) {
		// 		this.googleClanderAuthCallBack(code);
		// 	}
		// });
		this.getAllMentors();
		this.mentorEmail = localStorage.getItem('email');
	}

	openBookSessionDialog(mentor: GetMentorList) {
		if (!this.mentorEmail) {
			this._toastr.warning('Please add your email before booking a session.');
			this.router.navigate(['/student-dashboard/profile'], { queryParams: { returnUrl: '/student-dashboard/mentors' } });
			return;
		}
		this.dialog.open(MentorBookSessionDialogComponent, {
			data: {
				mentor_id: mentor.mentor_id,
				first_name: mentor.first_name,
				last_name: mentor.last_name,
				designation: mentor.designation,
				company: mentor.company,
			}
		})
	}

	goToSessionPage() {
		this.router.navigateByUrl('/student-dashboard/my-sessions');
	}

	getAllMentors(loadMore = false) {
		this.isMentor = true;
		this.subscription.add(
			this._mentorService.getAllMentors(this.page, this.limit).pipe(
				tap(response => {
					if (response.Success) {
						this.mentorsCount = response.Data.total_count;
						this.totalPages = response.Data.total_pages;
						if (loadMore) {
							this.mentors = [...this.mentors, ...response.Data.mentors];
						} else {
							this.mentors = response.Data.mentors;
						}
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isMentor = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching mentors');
					return of(null);
				})
			).subscribe()
		);
	}

	// googleAuthUrl() {
	// 	const redirectUri = environment.baseRedirectCalanderUrl;
	// 	this.subscription.add(
	// 		this._mentorService.getGoogleCalenderAuthUrl(redirectUri).pipe(
	// 			tap(response => {
	// 				if (response) {
	// 					window.location.href = response.oauth_url;
	// 				}
	// 				})
	// 		).subscribe()
	// 	);
	// }

	// googleClanderAuthCallBack(code: string) {
	// 	const redirectUri = environment.baseRedirectCalanderUrl;
	// 	this.subscription.add(
	// 		this._mentorService.getGoogleCalenderAuthCallBack(code, redirectUri).pipe(
	// 			tap(response => {
	// 				if (response.Success) {
	// 					this._toastr.success(response.Message);
	// 					this.router.navigate(['/student-dashboard/mentors']);
	// 				} else {
	// 					this._toastr.error(response.Message);
	// 				}
	// 			})
	// 		).subscribe()
	// 	);
	// }

	// postMentorSessionRefreshToken(mentor: GetMentorList, index: number) {
	// 	this.isLoadingIndex = index;
	// 	this.subscription.add(
	// 		this._mentorService.postMentorSessionRefreshToken().pipe(
	// 			tap(response => {
	// 				if (!response.Success) {
	// 					this.googleAuthUrl();
	// 				} else {
	// 					this.openBookSessionDialog(mentor);
	// 				}
	// 			}),
	// 			finalize(() => {
	// 				this.isLoadingIndex = null;
	// 			}),
	// 			catchError(() => {
	// 				this._toastr.error('Something went wrong');
	// 				return of(null);
	// 			})
	// 		).subscribe()
	// 	);
	// }

	loadMore() {
		if (this.page < this.totalPages) {
			this.page++;
			this.getAllMentors(true);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}